import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Checkbox as MCheckbox,
} from '@material-ui/core';
import get from 'lodash.get';

const Checkbox = ({name, label, labelPlacement}) => {
    const {control, errors} = useFormContext();
    const error = get(errors, name);

    return (
        <FormControl fullWidth error={!!error}>
            <Controller
                render={p => (
                    <FormControlLabel
                        label={label}
                        labelPlacement={labelPlacement}
                        control={
                            <MCheckbox
                                data-cy={`form-field-${name}-${p.value}`}
                                onChange={e => p.onChange(e.target.checked)}
                                checked={p.value}
                            />
                        }
                    />
                )}
                control={control}
                name={name}
            />
            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    );
};

export default Checkbox;
